import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { StorageService } from '../../../services/storage.service';
import { UserService } from '../../../services/user.service';
import { NotificationService } from '../../../services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  userData: any;
  version: any;
  isLoading: boolean = false;
  accType: string;
  brandName: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private user: UserService,
    private store: StorageService,
    private http: ApiService,
    private notify: NotificationService
  ) {
    try {
      const rawAccType = this.store.get('acc_type');
      const rawCompanyName = this.store.get('companyName');
      if (rawCompanyName.length > 1) {
          this.brandName = 'AzeApp';
        } else {
          this.brandName = rawCompanyName[0].companyName || 'AzeApp';
        }
      this.accType =
        rawAccType !== undefined && rawAccType !== null
          ? rawAccType.toString()
          : '';
      console.log('riyas', this.accType, typeof this.accType); // should log string
    } catch (error) {
      console.error('Error retrieving or parsing acc_type:', error);
    }
  }

  ngOnInit() {
    this.isLoading = true;

    this.route.data.subscribe(() => {
      this.user.getProfileDetails(`retailers/getProfileDetails`).subscribe({
        next: (data: any) => {
          this.userData = {
            ...data.data,
            accountTypeLabel: this.getAccountTypeLabel(data.data.accountType),
          };
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error fetching profile:', error);
          this.isLoading = false;
        },
      });
    });
  }

  getAccountTypeLabel(type: number): string {
    switch (type) {
      case 1:
        return 'Buyer';
      case 2:
        return 'Seller';
      case 3:
        return 'Buyer/Seller';
      default:
        return 'Unknown';
    }
  }

  async confirmSignout() {
    const confirm = window.confirm('Are you sure you want to sign out?');
    if (confirm) {
      this.signout();
    }
  }

  async signout() {
    this.isLoading = true;
    this.http.get('retailers/logout').subscribe();

    setTimeout(() => {
      this.isLoading = false;
      this.store.clearStore();
      this.user.reset();
      this.router.navigate(['/types']);
    }, 300);
  }

  // async uploadUserImage() {
  //   const showOptions = confirm('View existing image?');

  //   if (this.userData.img && showOptions) {
  //     const view = confirm('View Image?');
  //     if (view) return this.viewFile(this.userData.img);
  //     const del = confirm('Delete Image?');
  //     if (del) return this.removeImg(this.userData.id);
  //   }

  //   const takePhoto = confirm('Do you want to take a new photo?');
  //   if (takePhoto) return this.selectImage();

  //   const pickLibrary = confirm('Select from library?');
  //   if (pickLibrary) return this.selectImage();
  // }

  async uploadUserImage() {
    if (this.userData.img) {
      const { value: action } = await Swal.fire({
        title: 'Profile Image Options',
        text: 'What would you like to do?',
        icon: 'info',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'View',
        denyButtonText: 'Delete',
        cancelButtonText: 'Skip',
      });

      if (action === true) {
        return this.viewFile(this.userData.img);
      } else if (action === false) {
        return this.removeImg(this.userData.id);
      }
    }

    const { value: photoOption } = await Swal.fire({
      title: 'Upload Photo',
      text: 'Choose how to upload a photo',
      icon: 'question',
      input: 'radio',
      inputOptions: {
        camera: 'Take a new photo',
        library: 'Select from library',
      },
      inputValidator: (value) => {
        if (!value) {
          return 'You need to choose one option!';
        }
        return null;
      },
      confirmButtonText: 'Continue',
    });

    if (photoOption) {
      return this.selectImage();
    }
  }

  removeImg(id: number) {
    this.http
      .get('retailers/deleteAsset', { params: { id } })
      .subscribe((res) => {
        if (res.code == 1) {
          this.userData = { ...this.userData, img: '', imgId: '' };
          this.notify.showSuccess(res.message, '');
        } else {
          this.notify.showError(res.message, '');
        }
      });
  }

  // Replacing the camera with a file input for web-only apps
  selectImage() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';

    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append('filename', file, file.name);
        formData.append('type', '3');
        this.uploadImage(formData);
      }
    };

    fileInput.click();
  }

  uploadImage(formData: FormData) {
    this.isLoading = true;

    this.http
      .filePost('retailers/updateUserProfileImage', formData)
      .subscribe((res: any) => {
        this.isLoading = false;
        if (res.code == 1) {
          this.userData = {
            ...this.userData,
            img: res.data.url,
            imgId: res.data.id,
          };
          this.notify.showSuccess(res.message, '');
        } else {
          this.notify.showError(res.message, '');
        }
      });
  }

  viewFile(imgUrl: string) {
    Swal.fire({
      title: 'Profile Picture',
      imageUrl: imgUrl,
      imageAlt: 'User Image',
      imageWidth: 300,
      imageHeight: 300,
      showCloseButton: true,
      showConfirmButton: false,
      background: '#fff',
      backdrop: `rgba(0, 0, 0, 0.7)`,
      customClass: {
        popup: 'rounded-xl shadow-lg',
      },
    });
  }

  navigateToChangePassword() {
    this.router.navigate(['/dashboard/profile/change-password']);
  }

  goBack() {
    this.router.navigate(['/dashboard/home']);
  }

  navigateToSavedAddresses() {
    this.router.navigate(['/dashboard/profile/saved-addresses']);
  }
}
